import { render, staticRenderFns } from "./CallToAction.vue?vue&type=template&id=20da03a0"
import script from "./CallToAction.vue?vue&type=script&lang=ts"
export * from "./CallToAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports